var map = {
	"./web-p2-t1.svg": "eb97",
	"./web-p2-t2.svg": "b15c",
	"./web-p2-t3.svg": "551a",
	"./web-p2-t4.svg": "4eb4",
	"./web-p2-t5.svg": "6d11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f8d7";